// extracted by mini-css-extract-plugin
export default {"title":"TranslationChecker_title__65OBq"};